import React from "react";
import "./WebDesign.css";
import bannericonsvg1 from "../Images/Frame 1171277032.svg";
import bannericonsvg2 from "../Images/Frame 1171277065.svg";
import bannericonsvg3 from "../Images/Frame 1171277063.svg";
import bannericonsvg4 from "../Images/Frame 1171277064.svg";
import bannerproimg from "../Images/image 588254087 (2).png";
import mobilebannerproimg from "../Images/image 588254087 (3).png";
import starimg1 from "../Images/yellow-strs 1.svg";
import profileimg1 from "../Images/Group 1171275938.png";
import projectpic1 from "../Images/image 588254101 (2).png";
import projectpic2 from "../Images/image 588254102 (3).png";
import projectpic3 from "../Images/image 588254103 (2).png";
import projectpic4 from "../Images/image (7).png";
import arrowpic from "../Images/www.lazarev.agency-7 1.svg";
import profileimg3 from "../Images/Muhammad Qasim 2 (1).png";
import lastsecimg11 from "../Images/Group 1171276771.png";
import lastsecimg22 from "../Images/Group 1171276772.png";
import vectorsvgimg from "../Images/Vector (35).svg";
import { motion } from "framer-motion";

import TextAnimation from "./TextAnimations";
import { Helmet } from "react-helmet-async";

const fadeUpAnimation = {
  initial: { opacity: 0, y: 50 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 1, ease: "easeInOut" },
  viewport: { once: true, amount: 0.1 },
};

function WebDesign() {
  return (
    <div className="webdesign-main-div">
        <Helmet>
                <title>Website Design - Portfolio</title>
              </Helmet>
      {/* Section ###### No : ---------- 1 */}

      <motion.div
        {...fadeUpAnimation}
        className="container-fluid webdesign-banner-div11"
      >
        <div className="container">
          <div className="webdesign-banner-text-div1">
            <h1>
              <span>Conversion Focused</span>
              <br className="d-md-block d-none" /> Website Design
            </h1>

            <p>
              Helping{" "}
              <span>eCommerce, SaaS, and service-based businesses </span> grow
              with high- <br className="d-md-block d-none" />
              converting websites, smart CRO strategies, and data-driven design.
            </p>
            <div className="d-md-none d-block">
              <img
                src={mobilebannerproimg}
                className="img-flui mobile-banner-webdesign-img"
                alt=""
              />
            </div>

            <div className="row ">
              <div className="col-lg-3 col-6">
                <div className="webdesign-banner-text-div2">
                  <img src={bannericonsvg1} alt="" />
                  <h6>Optimize & Convert</h6>
                </div>
              </div>

              <div className="col-lg-3 col-6">
                <div className="webdesign-banner-text-div2">
                  <img src={bannericonsvg2} alt="" />
                  <h6>Industry Leading UX</h6>
                </div>
              </div>

              <div className="col-lg-3 col-6">
                <div className="webdesign-banner-text-div2">
                  <img src={bannericonsvg3} alt="" />
                  <h6>A Fresh Perspective</h6>
                </div>
              </div>

              <div className="col-lg-3 col-6">
                <div className="webdesign-banner-text-div2">
                  <img src={bannericonsvg4} alt="" />
                  <h6>Boost Your Paid ROI</h6>
                </div>
              </div>
            </div>

            <div className="banner-book-call-web-design-btn d-md-none">
              <a href="https://calendly.com/iamqasim/30min" target='_blank'>
                <div>Book a Call →</div>
              </a>
              <p>🚀 Design + Conversion, Together.</p>
            </div>
          </div>
        </div>
      </motion.div>

      {/* Section ###### No : ---------- 2  */}

      <motion.div
        {...fadeUpAnimation}
        className="container-fluid banner-project-div11 d-md-block d-none"
      >
        <div>
          <img src={bannerproimg} alt="" />
        </div>
      </motion.div>

      {/* Section ###### No : ---------- 3 */}

      <motion.div
        {...fadeUpAnimation}
        className="container-fluid webdesign-want-sec-div1"
      >
        <div className="container">
          <div className="webdesign-want-sec-div2 text-center">
            <div>
              <h1>
                <span>🔥If you</span> want to
              </h1>
              <div className="want-sec-line1"></div>

              <ul>
                <li>
                  ✅ <span>Redesign a website</span> that actually performs?
                  That’s my thing.
                </li>
                <li>
                  ✅ <span>Improve conversions</span> on your landing pages?
                  I’ve got you.
                </li>
                <li>
                  ✅ <span>Increase AOV</span> in your online store? Let’s make
                  it happen.
                </li>
                <li>
                  ✅ <span>Improve retention</span> in your web app? You’re in
                  the right place.
                </li>
              </ul>
              <div className="want-sec-line1"></div>
            </div>
            <div className="want-sec-review-div1">
              <div>
                <h5>1200+</h5>
                <h5> 5 star reviews</h5>
                <img src={starimg1} className="star-web-want-sec-img1" alt="" />
                <img
                  src={profileimg1}
                  className="star-web-want-sec-img2"
                  alt=""
                />
              </div>
            </div>
            <div className="banner-book-call-web-design-btn">
              <a href="https://calendly.com/iamqasim/30min" target='_blank'>
                <div>Book a Call →</div>
              </a>
              <p>🚀 Design + Conversion, Together.</p>
            </div>
          </div>
        </div>
      </motion.div>

      {/* Section ###### No : ---------- 4 */}

      <motion.div
        {...fadeUpAnimation}
        className="container-fluid webdesign-portfolio-sec-div1"
      >
        <div className="container">
          <div className="portfolio-sec-text-div1">
            <div>
              <h1>
                <span>Proven Results,</span> Trusted by Real Clients
              </h1>
              <p>
                Design<span> that works</span> — beyond just looking good.
              </p>
            </div>
            <div className="row">
              <motion.div {...fadeUpAnimation} className="col-lg-6">
                <div className="portfolio-sec-text-div2">
                  <a href='https://myaccentway.com/' target="_blank">
                  <div>
                    <img src={projectpic1} className="img-fluid" alt="" />
                  </div>
                  <div className="portfolio-sec-text-div3">
                    <div>
                      <h2>My Accent Way</h2>
                      <h6>Boosted trial sign-ups by 32% with CRO improvements.</h6>
                    </div>
                    <div>
                      <img src={arrowpic} alt="" />
                    </div>
                  </div>
                  </a>
                </div>
              </motion.div>

              <motion.div {...fadeUpAnimation} className="col-lg-6">
                <div className="portfolio-sec-text-div2">
                  <a href='https://www.shinie.de/' target="_blank">
                  <div>
                    <img src={projectpic2} className="img-fluid" alt="" />
                  </div>
                  <div className="portfolio-sec-text-div3">
                    <div>
                      <h2>Shinie</h2>
                      <h6>Improved AOV by 35% through mobile-first design.</h6>
                    </div>
                    <div>
                      <img src={arrowpic} alt="" />
                    </div>
                  </div>
                  </a>
                </div>
              </motion.div>

              <motion.div {...fadeUpAnimation} className="col-lg-6">
                <div className="portfolio-sec-text-div2">
                  <a href='https://pkcargo.co.uk/' target="_blank">
                  <div>
                    <img src={projectpic3} className="img-fluid" alt="" />
                  </div>
                  <div className="portfolio-sec-text-div3">
                    <div>
                      <h2>Pk Cargo</h2>
                      <h6>Cut bounce rate by 40% with streamlined navigation.</h6>
                    </div>
                    <div>
                      <img src={arrowpic} alt="" />
                    </div>
                  </div>
                  </a>
                </div>
              </motion.div>

              <motion.div {...fadeUpAnimation} className="col-lg-6">
                <div className="portfolio-sec-text-div2">
                  <a href='https://zumwax.com/' target="_blank">
                  <div>
                    <img src={projectpic4} className="img-fluid" alt="" />
                  </div>
                  <div className="portfolio-sec-text-div3">
                    <div>
                      <h2>Zum Wax</h2>
                      <h6>28% boost in conversions after optimizing user flow and product discovery.</h6>
                    </div>
                    <div>
                      <img src={arrowpic} alt="" />
                    </div>
                  </div>
                  </a>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </motion.div>

      {/* Section ###### No : ---------- 5  */}

      <motion.div
        {...fadeUpAnimation}
        className="container-fluid webdesign-choice-div1 pl-0 pr-0"
      >
        <div className="webdesign-choice-div2233">
          <div className="container">
            <div>
              <div className="web-choice-sec-img-div1">
                <img src={profileimg3} />
              </div>

              <div className="web-choice-sec-text-div">
                <h1>
                  <span className="spans11 ">Why I’m the Right Choice</span> for
                  Your <br className="d-md-block d-none" /> Website Design &
                  <span className="spans22 "> Conversion Needs </span>
                </h1>
                <p>
                  <span>Not just a designer </span>a problem-solver focused on
                  business growth.
                </p>
              </div>

              <div className="row web-choice-sec-row-div">
                <div className="col-lg-6">
                  <div className="web-choice-sec-text-div22">
                    <div>
                      <h4> 🎯</h4>
                    </div>
                    <div>
                      <h2>Conversion-Focused Thinking</h2>
                      <h6>
                        I design websites with the end goal in mind: more{" "}
                        <br className="d-md-block d-none" /> leads, more sales,
                        and better ROI.
                      </h6>
                    </div>
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="web-choice-sec-text-div22">
                    <div>
                      <h4> 🧠 </h4>
                    </div>
                    <div>
                      <h2>Strategy Meets Creativity</h2>
                      <h6>
                        Every design decision is backed by data and driven by{" "}
                        <br className="d-md-block d-none" />
                        proven UX & CRO principles not just guesswork.
                      </h6>
                    </div>
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="web-choice-sec-text-div22">
                    <div>
                      <h4> 🎨 </h4>
                    </div>
                    <div>
                      <h2>15 years of experience</h2>
                      <h6>
                        I’ve spent over a decade crafting websites that don’t{" "}
                        <br className="d-md-block d-none" /> just look great
                        they drive real business growth.
                      </h6>
                    </div>
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="web-choice-sec-text-div22">
                    <div>
                      <h4> 🌎 </h4>
                    </div>
                    <div>
                      <h2>Worked With 200+ Clients</h2>
                      <h6>
                        I design interfaces and systems that scale across{" "}
                        <br className="d-md-block d-none" /> industries and
                        platforms.
                      </h6>
                    </div>
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="web-choice-sec-text-div22">
                    <div>
                      <h4> 🚀 </h4>
                    </div>
                    <div>
                      <h2>Scaled 7–8 Figure Brands</h2>
                      <h6>
                        I know what high-performing websites need to{" "}
                        <br className="d-md-block d-none" /> support serious
                        revenue.
                      </h6>
                    </div>
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="web-choice-sec-text-div22">
                    <div>
                      <h4> 📈 </h4>
                    </div>
                    <div>
                      <h2>Real Results</h2>
                      <h6>
                        My goal isn’t to just make your site look good. It's to{" "}
                        <br className="d-md-block d-none" /> make it perform.
                      </h6>
                    </div>
                  </div>
                </div>
              </div>

              <div className="request-free-btn-12">
                <a href="https://calendly.com/iamqasim/30min" target='_blank'>
                  <div>Request a Free Consultation</div>
                </a>
              </div>

              <div className="choice-design-sec-text11">
                <p>🚀 Design + Conversion, Together.</p>
              </div>
            </div>
          </div>
        </div>
      </motion.div>

      {/* Section ###### No : ---------- 6  */}

      <motion.div
        {...fadeUpAnimation}
        className="container-fluid webdesign-funnel-div1"
      >
        <div className="container">
          <div className=" webdesign-funnel-text-div1 text-center ">
            <h1>
              Your current funnel might be <br className="d-md-block d-none" />
              <span> leaking more $</span> than you think
            </h1>
            <div className="web-design-error-div">
              <h6>⛔ Error</h6>
            </div>
            <div className="row">
              <motion.div {...fadeUpAnimation} className="col-lg-6">
                <div>
                  <img src={lastsecimg11} alt="" />
                </div>
              </motion.div>

              <motion.div {...fadeUpAnimation} className="col-lg-6">
                <div>
                  <img src={lastsecimg22} alt="" />
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </motion.div>

      {/* Section ###### No : ---------- 7  */}

      <motion.div
        {...fadeUpAnimation}
        className="container-fluid webdesign-ready-div1 text-center"
      >
        <div className="container">
          <div>
            <h1>
              <span>Ready to</span> level up your Website
            </h1>
            <p>
              I work with brands ready to stop guessing and start converting.
              Let’s turn <br className="d-md-block d-none" /> your traffic into
              results with smart, strategy-first design.
            </p>
            <div className="banner-book-call-web-design-btn">
              <a href="https://calendly.com/iamqasim/30min" target='_blank'>
                <div>Let’s Build Something That Converts →</div>
              </a>
              <p>🚀 Design + Conversion, Together.</p>
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  );
}

export default WebDesign;
